export const socialMediaData = [
    {
        href: 'https://www.instagram.com/studionorcat',
        icon: 'instagram',
        label: 'Studio NORCAT on Instagram',
    },
    {
        href: 'https://www.youtube.com/channel/UCIE8m9rM9znVklfDHz6f16Q',
        icon: 'youtube',
        label: 'Studio NORCAT on YouTube',
    },
    {
        href: 'https://x.com/studionorcat',
        icon: 'x-twitter',
        label: 'Studio NORCAT on X',
    },
];
